export enum FaqSlugB2C {
  ABOUT_BOLT = 'about-bolt',
  BILL_SHOCK = 'bill-shock',
  COMMUNITY_SALES = 'community-sales',
  CONSUMPTION = 'consumption',
  ENERGY_OVERVIEW = 'energy-overview',
  INVOICES_AND_PAYMENTS = 'invoices-and-payments',
  MARKET_PRICES = 'market-prices',
  MOVE = 'move',
  MY_ADDRESSES = 'my-addresses',
  MY_DETAILS = 'my-details',
  MY_PRODUCER = 'my-producer',
  PAYMENT = 'payment',
  PHISHING = 'phishing',
  SWITCH = 'switch',
  TARIFFS = 'tariffs',
  BOLT_FIX_OPT_IN = 'bolt-fix-opt-in'
}

export enum FaqSlugB2B {
  INJECTION = 'injection',
  INVOICES = 'invoices',
  GVO = 'gvo',
  ABOUT_BOLT = 'about-bolt-b2b'
  //  ENERGY_SHARING = 'energy-sharing'
}

// Used to filter out FAQ questions in the FAQ Drawer based on certain conditions
export enum FaqTags {
  BILLING_CYCLES = 'billing-cycles',
  INSTALMENTS = 'instalments'
}
